import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import classNames from "classnames";
import { INTERNAL_USER_ONLY, defaultPropertiesOverride } from "../../constants";
import { getClassName, getTypeClassName, getRowHeaderClassName, getRenderer } from "../../utils";
import { ShowMore } from "../ShowMore";
import InternalIcon from "../TableHeader/Icons/InternalIcon";
export var TableBody = function TableBody(_ref) {
  var rows = _ref.rows,
      getColumnProps = _ref.getColumnProps,
      getCellProps = _ref.getCellProps,
      getRowProps = _ref.getRowProps,
      prepareRow = _ref.prepareRow,
      enableShowMore = _ref.enableShowMore,
      maxTextLength = _ref.maxTextLength;
  var lastRow = rows.length - 1;

  var getColumnValue = function getColumnValue(columnValue, isInternal, columnIndex) {
    if (isInternal && columnIndex === 0) {
      return /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "internalRow"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "internalIcon"
        })
      }, InternalIcon), columnValue, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "tooltip"
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: getClassName({
          descendantName: "tooltipText"
        })
      }, INTERNAL_USER_ONLY)));
    } else if (isInternal) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, columnValue, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "tooltip"
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: getClassName({
          descendantName: "tooltipText"
        })
      }, INTERNAL_USER_ONLY)));
    }

    return columnValue;
  };

  var getTableBodyCell = function getTableBodyCell(cell, index, columnIndex) {
    var _cell$value, _cell$value$props;

    var column = cell.column;
    var type = column.type,
        rowHeader = column.rowHeader,
        className = column.className,
        style = column.style,
        internal = column.internal,
        formatCell = column.formatCell,
        renderSelectionCell = column.renderSelectionCell;
    var renderer = formatCell || getRenderer(type);
    var cellComponent = cell.render(renderer);
    var isHeaderCell = cell === null || cell === void 0 ? void 0 : (_cell$value = cell.value) === null || _cell$value === void 0 ? void 0 : (_cell$value$props = _cell$value.props) === null || _cell$value$props === void 0 ? void 0 : _cell$value$props.header;
    var Element = rowHeader || isHeaderCell ? "th" : "td";
    var cellProps = cell.getCellProps([defaultPropertiesOverride, rowHeader || isHeaderCell ? {
      scope: "row"
    } : {}, (getColumnProps === null || getColumnProps === void 0 ? void 0 : getColumnProps(column)) || {}, (getCellProps === null || getCellProps === void 0 ? void 0 : getCellProps(cell)) || {}]);
    var columnValue = typeof (cell === null || cell === void 0 ? void 0 : cell.value) === "string" && !formatCell ? /*#__PURE__*/React.createElement(ShowMore, {
      enableShowMore: enableShowMore,
      maxTextLength: maxTextLength,
      cell: cell
    }) : cellComponent;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Element, _extends({}, cellProps, {
      style: style,
      className: classNames(getClassName({
        descendantName: "cell",
        modifiers: "body"
      }), getTypeClassName(type), rowHeader && getRowHeaderClassName(), className, internal && getClassName({
        descendantName: index === lastRow ? "internalLast" : "internal"
      }))
    }), renderSelectionCell ? cell.render(renderSelectionCell(cellComponent)) : getColumnValue(columnValue, // eslint-disable-next-line
    String(cell.row.original["internal"]) === "true" || !!internal, columnIndex)));
  };

  var getBodyRow = function getBodyRow(row, index) {
    prepareRow(row);
    var rowProps = row.getRowProps([defaultPropertiesOverride, (getRowProps === null || getRowProps === void 0 ? void 0 : getRowProps(row)) || {}]);
    var rowClassName = getClassName({
      className: (rowProps === null || rowProps === void 0 ? void 0 : rowProps.className) || "",
      descendantName: "row",
      modifiers: classNames("body", row.isSelected ? "selected" : null, // eslint-disable-next-line
      String(row.cells[0].row.original["internal"]) === "true" ? "internal" : null)
    });
    return /*#__PURE__*/React.createElement("tr", _extends({}, rowProps, {
      className: rowClassName
    }), row.cells.map(function (cell, columnIndex) {
      return getTableBodyCell(cell, index, columnIndex);
    }));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, rows.map(function (row, index) {
    return getBodyRow(row, index);
  }));
};